export default "__VITE_ASSET__CYmjc7LJ__"